export default __webpack_public_path__ + "static/media/i149vp.289ce107.webp";